<div mat-dialog-title>
  <h2 class="my-0">
    {{'map.print_map_component.title_modal' | translate}}
  </h2>
</div>
<div mat-dialog-content>
  <div class="content-grid">

    <div class="preview-box">
      <canvas id="canvas-map" style="display: none;"></canvas>
      <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    <div class="preview-form" *ngIf="settingsForm">
      <form class="d-flex gap-2 flex-column" [formGroup]="settingsForm">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'print.title' | translate}}</mat-label>
          <input matInput formControlName="title">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100" (click)="fileInput.click()">
          <mat-label>{{'print.choose__image' | translate}}</mat-label>

          <div class="d-flex justify-space-between">
            <input matInput formControlName="image_">
            <mat-icon class="me-2" matSuffix>file_upload</mat-icon>
          </div>

          <input #fileInput type="file" accept=".jpg, .jpeg, .png" (change)="onFileSelect($event)" hidden>
        </mat-form-field>

        <hr>

        <mat-button-toggle-group formControlName="orientation" class="w-100 orientation-toggle-group">
          <mat-button-toggle value="landscape" matTooltip="{{'print.landscape' | translate}}">
            <mat-icon>crop_landscape</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="portrait" matTooltip="{{'print.portrait' | translate}}">
            <mat-icon>crop_portrait</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'print.dimension' | translate}}</mat-label>
          <mat-select formControlName="dim">
            <mat-option *ngFor="let dim of dimOptions" [value]="dim.value">
              <div class="d-flex align-items-center">
                <div class="text-capitalize"> {{dim.label}}</div>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <hr>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'print.dpi' | translate}}</mat-label>
          <mat-select formControlName="dpi">
            <mat-option *ngFor="let dpi of dpiOptions" [value]="dpi.value">
              <div class="d-flex align-items-center">
                <div class="text-capitalize"> {{dpi.label}}</div>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'print.scale' | translate}}</mat-label>
          <mat-select formControlName="scale">
            <mat-option *ngFor="let scale of scaleOptions" [value]="scale.value">
              <div class="d-flex align-items-center">
                <div class="text-capitalize"> {{scale.label}}</div>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col">
      <ul class="tools">
        <li>
          <input (change)="addHeaderImg($event)" type="file" id="upload" accept=".png,.jpeg,.jpg" hidden #upload />
          <label class="label-button mat-flat-button" for="upload"> {{'map.print_map_component.add_header_img' |
            translate}}</label>

          <mat-icon class="me-2 clickable info-button" [inline]="true" color="accent"
            [matTooltip]="'map.print_map_component.help_info' | translate" matTooltipPosition="above"
            matTooltipClass="info-button-tooltip">info</mat-icon>
        </li>
        <li>
          <button mat-flat-button color="primary" (click)="addScale()"> {{'map.print_map_component.add_scale' |
            translate}}</button>
        </li>
        <li>
          <button mat-flat-button color="primary" (click)="clear()"> {{'map.print_map_component.reset' |
            translate}}</button>
        </li>
      </ul>
    </div>
  </div> -->

</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary" class="mx-2">
    {{'common.close' | translate}}
  </button>

  <div id="dpi" style="height: 1in; width: 1in; left: 100%; position: fixed; top: 100%;">sberembe</div>
  <button mat-raised-button color="primary" id="image-download" download="map.png" (click)="downloadPDF()">
    {{'map.print_map_component.create_pdf' | translate}}
  </button>
</div>


